import React from 'react';

const FilterSectionForUser = ({ Filter, setFilter, handleOrderFilter, handleReset }) => {
	// Reusable handler for setting filter values
	const handleFilterChange = (e) => {
		const { name, value } = e.target;

		// Allow only numeric values
		if (name === 'MobileNo' && !/^\d*$/.test(value)) {
			return; // Prevent non-numeric input
		}

		setFilter((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	return (
		<>
			<div className='flex items-center space-x-4  '>
				<div className=' flex flex-wrap gap-3 lg:mb-8 mb-4'>
					<div className=' lg:w-auto w-[40%] max-[300px]:w-full'>
						<input
							type='text'
							name='MobileNo'
							placeholder='Mobile Number'
							autoComplete='off'
							className='p-2 border rounded w-full max-lg:text-sm max-[400px]:text-xs'
							value={Filter.MobileNo}
							onChange={handleFilterChange}
						/>
					</div>
					<div className='flex flex-row gap-3 w-1/2 lg:w-auto max-[300px]:w-full'>
						<button
							type='button'
							onClick={handleOrderFilter}
							className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
							Search
						</button>

						<button
							type='button'
							onClick={handleReset}
							className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
							Reset
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default FilterSectionForUser;
